webpackJsonp([8,11],{

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-56d98325]{visibility:hidden;height:0}.business-page[data-v-56d98325]{background:url(" + __webpack_require__(327) + ") no-repeat top;width:100%;height:894px;margin:0 auto;position:relative;-ms-flex-pack:center;justify-content:center}.business-page .content[data-v-56d98325],.business-page[data-v-56d98325]{display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.business-page .content[data-v-56d98325]{height:550px;width:750px;border-radius:50%;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between}.business-page .content .desc[data-v-56d98325]{width:100%;color:#616161;line-height:25px;float:left;text-align:center}.business-page .content .contact[data-v-56d98325]{color:#616161}.business-page .content .contact p[data-v-56d98325]{margin-bottom:10px}.business-page .content .submit[data-v-56d98325]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.business-page .content .submit p[data-v-56d98325]{font-size:25px;margin-bottom:20px}.business-page .content .submit .submit-btn[data-v-56d98325]{background:#fda941;color:#fff;width:120px;height:40px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;border-radius:5px;text-decoration:none}", "", {"version":3,"sources":["/./src/components/Business.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,gCAAgC,uDAAwE,WAAW,aAAa,cAAc,kBAAkB,AAAiC,qBAAqB,sBAAuB,CAC5O,AACD,yEAFgK,oBAAoB,aAAa,AAA4C,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CAGlW,AADD,yCAAyC,aAAa,YAAY,kBAAkB,AAAiC,0BAA0B,sBAAsB,sBAAsB,6BAA8B,CACxN,AACD,+CAA+C,WAAW,cAAc,iBAAiB,WAAW,iBAAiB,CACpH,AACD,kDAAkD,aAAa,CAC9D,AACD,oDAAoD,kBAAkB,CACrE,AACD,iDAAiD,oBAAoB,aAAa,0BAA0B,sBAAsB,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACnS,AACD,mDAAmD,eAAe,kBAAkB,CACnF,AACD,6DAA6D,mBAAmB,WAAW,YAAY,YAAY,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,kBAAkB,oBAAoB,CAC5V","file":"Business.vue","sourcesContent":["\n.blank[data-v-56d98325]{visibility:hidden;height:0\n}\n.business-page[data-v-56d98325]{background:url(\"../../static/img/business_bg.jpg\") no-repeat top center;width:100%;height:894px;margin:0 auto;position:relative;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.business-page .content[data-v-56d98325]{height:550px;width:750px;border-radius:50%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.business-page .content .desc[data-v-56d98325]{width:100%;color:#616161;line-height:25px;float:left;text-align:center\n}\n.business-page .content .contact[data-v-56d98325]{color:#616161\n}\n.business-page .content .contact p[data-v-56d98325]{margin-bottom:10px\n}\n.business-page .content .submit[data-v-56d98325]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.business-page .content .submit p[data-v-56d98325]{font-size:25px;margin-bottom:20px\n}\n.business-page .content .submit .submit-btn[data-v-56d98325]{background:#fda941;color:#fff;width:120px;height:40px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;border-radius:5px;text-decoration:none\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(248);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-56d98325&scoped=true!../../node_modules/sass-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Business.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-56d98325&scoped=true!../../node_modules/sass-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Business.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/business_bg.38abca9.jpg";

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(299)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(377),
	  /* scopeId */
	  "data-v-56d98325",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 377:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "business-page"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('p', {
	    staticClass: "desc",
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('content'))
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "contact"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('developCooperation')) + "：business@mngo.com")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('issueCooperation')) + "：business@enjoygame.com")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('hr')) + "：zhaopin@mngo.com")])])])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.4c261bcf1fc32980e187.js